import React from "react";
import { Link, Navigate } from "react-router-dom";
import { FaUserFriends } from "react-icons/fa";
import DashboardDriversMetrics from "../components/DashboardDriversMetrics";
import { useProfile } from "../context/ProfileContext";
import { getAdminLandingPath } from "../utils/adminLanding";

const DriversMetrics = () => {
  const { profile, assignModule, loading } = useProfile();
  const isSuperAdmin = profile?.role?.slug === "superadmin";

  if (loading) return null;
  if (!isSuperAdmin) {
    return <Navigate to={getAdminLandingPath(profile, assignModule)} replace />;
  }

  return (
    <div className="container mx-auto px-6 py-8 bg-gray-50 min-h-screen">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8">
        <div className="flex items-center space-x-3">
          <FaUserFriends className="text-3xl text-blue-600" />
          <div>
            <h2 className="text-3xl font-bold text-gray-800">Drivers Metrics</h2>
            <p className="text-sm text-gray-600">Detailed driver analytics and onboarding metrics.</p>
          </div>
        </div>
        <Link
          to="/dashboard"
          className="inline-flex items-center justify-center px-4 py-2 bg-white border border-gray-300 rounded-lg shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-100"
        >
          Back to Dashboard
        </Link>
      </div>
      <DashboardDriversMetrics />
    </div>
  );
};

export default DriversMetrics;
